
import { useEffect } from 'react';
import Navbar from '../home/components/Navbar';
import Footer from '../home/components/Footer';

export default function TermsOfService() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const today = new Date().toLocaleDateString('en-US', { 
    year: 'numeric', 
    month: 'long', 
    day: 'numeric' 
  });

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      <main className="pt-32 pb-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12">
          <h1 className="text-5xl font-bold text-[#2C2C2C] mb-6" style={{ fontFamily: 'Literata, serif' }}>
            Terms of Service
          </h1>
          <p className="text-gray-600 mb-12">Last updated: {today}</p>

          <div className="space-y-10 text-[#2C2C2C]" style={{ fontFamily: 'Literata, serif' }}>
            <section>
              <p className="text-gray-700 leading-relaxed mb-4">
                These Terms govern your use of the I Say I Am app ("the App"). By using the App, you agree to these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Use of the App</h2>
              <p className="text-gray-700 leading-relaxed">
                You agree to use the App only for lawful purposes and in accordance with these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Ownership</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The App, its design, interface, graphics, text, audio, and all related intellectual property belong to Think Heart Apps AB.
              </p>
              <p className="text-gray-700 leading-relaxed">
                You may not copy, modify, distribute, or reverse-engineer the App.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">User Content</h2>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Any text you create inside the App (journal entries, reflections, notes) is your property.</li>
                <li>We do not claim ownership of your content, and we do not store it on our servers.</li>
                <li>You are responsible for backing up your content.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Subscriptions & Payments</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                If the App offers premium features:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Payments are handled by the App Store or Google Play</li>
                <li>Subscriptions auto-renew unless cancelled</li>
                <li>Refunds are handled by the store, not us</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Disclaimer</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                The App provides wellness guidance and self-reflection tools. It does not replace therapy, professional mental health services, or medical treatment.
              </p>
              <p className="text-gray-700 leading-relaxed">
                Use the App at your own discretion.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Limitation of Liability</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                To the fullest extent permitted by law, we are not liable for:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Data loss</li>
                <li>Misuse of the App</li>
                <li>Unavailable services</li>
                <li>Any indirect or consequential damages</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Termination</h2>
              <p className="text-gray-700 leading-relaxed">
                We may suspend or terminate access to the App if you misuse it or violate these Terms.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Governing Law</h2>
              <p className="text-gray-700 leading-relaxed">
                These Terms are governed by Swedish law.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold mb-4">Contact</h2>
              <p className="text-gray-700 leading-relaxed">
                For any questions: <a href="mailto:hello@thinkheart.co" className="text-[#FF6B6B] hover:underline cursor-pointer">hello@thinkheart.co</a>
              </p>
            </section>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
